var React = require('react');

function RightArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.1317 3.71209C10.7656 3.34597 10.172 3.34597 9.80585 3.71209C9.43973 4.0782 9.43973 4.6718 9.80585 5.03791L13.8308 9.06291H3.90646C3.3887 9.06291 2.96896 9.48264 2.96896 10.0004C2.96896 10.5182 3.3887 10.9379 3.90646 10.9379H13.83L9.80585 14.9621C9.43973 15.3282 9.43973 15.9218 9.80585 16.2879C10.172 16.654 10.7656 16.654 11.1317 16.2879L16.7567 10.6629C17.1228 10.2968 17.1228 9.7032 16.7567 9.33708L11.1317 3.71209Z"}));
}

RightArrowInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = RightArrowInline;

RightArrowInline.default = RightArrowInline;
